import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useSkipMembershipsOnboardingStepMutation = createMutationHook(
  MembershipsCreatorApiClient.skipOnboardingStep,
  {
    mutationKey: ['skipMembershipsOnboardingStep'],
  },
)
